module.exports = __webpack_public_path__ + "img/progress2.442851bb.png";